module.exports = __webpack_public_path__ + "img/cloud.9541e1fa.svg";